module.exports = __webpack_public_path__ + "static/img/13.e97277e0.png";